import axiosServices from './request';

const MessageApi = axiosServices('/message/v1.0');

export default {
  // 发送手机短信
  sendMessage: MessageApi('post', 'shortMessage/sendPhoneMessageVerity'),
  // 重置密码时,发送验证码
  sendPhone: MessageApi('post', 'shortMessage/sendPhone')
};